import { z, zTimestamp } from '@harvestiq/zod';

export const createEventSchema = z.object({
  name: z.string(),
  value: z.string().optional(),
});
export type CreateEventRequest = z.infer<typeof createEventSchema>;

export const createEventResponseSchema = z.object({
  event: z.object({
    id: z.string().uuid(),
    entityId: z.string().uuid(),
    entityType: z.literal('User'),
    name: z.literal('hasCompletedOnboardingTour'),
    value: z.null(),
    createdAt: zTimestamp(),
    updatedAt: zTimestamp(),
  }),
});
export type CreateEventResponseSchema = z.infer<
  typeof createEventResponseSchema
>;
